import EditLicenseModal from '../containers/css-admin/licenses/EditLicenseModal'
import EditProductUserModal from '../containers/css-admin/users/EditProductUserModal'
import RebalanceSubscriptionModal from '../containers/css-admin/subscriptions/rebalance/RebalanceSubscriptionModal'
import EditTrainingModal from '../containers/css-admin/users/EditTrainingModal'
import RemoveUserTraining from '../containers/css-admin/users/RemoveUserTrainingModal'

export const modalMap = {
  editLicense: {
    component: EditLicenseModal,
    size: 'lg',
  },
  editProductUserModal: {
    component: EditProductUserModal,
  },
  RebalanceSubscriptionModal: {
    component: RebalanceSubscriptionModal,
    size: 'xl',
  },
  editTrainingModal: {
    component: EditTrainingModal,
    size: 'lg',
  },
  removeUserTrainingModal: {
    component: RemoveUserTraining,
  },
}



// WEBPACK FOOTER //
// ./src/lib/modals.js